
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"cc774093-8b64-45c7-8077-699a43d4914b","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 600 600","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"SVGID_1_","gradientUnits":"userSpaceOnUse","x1":"300","y1":"71.1","x2":"300","y2":"-467.1","gradientTransform":"translate(0 498)"}},[_c('stop',{attrs:{"offset":".01","stop-color":"gray","stop-opacity":".25"}}),_c('stop',{attrs:{"offset":".54","stop-color":"gray","stop-opacity":".12"}}),_c('stop',{attrs:{"offset":"1","stop-color":"gray","stop-opacity":".1"}})]),_c('path',{attrs:{"fill":"url(#SVGID_1_)","d":"M502.5 569.1h-405V98.7l61.2-67.8h343.8z"}}),_c('path',{attrs:{"fill":"#fff","d":"M496.2 554.8H104.6V102.4l59.2-65.2h332.4z"}}),_c('path',{staticClass:"st2",attrs:{"d":"M142.9 93h190.8v32.1H142.9zM143.3 181.1h139.8v32.1H143.3z"}}),_c('path',{attrs:{"fill":"#779eb7","d":"M143.3 313.4h313.6v118H143.3z"}}),_c('path',{staticClass:"st2",attrs:{"d":"M385.7 93.4h71.1v32.1h-71.1zM385.7 143.5h71.1v32.1h-71.1zM385.7 193.6h71.1v32.1h-71.1z"}}),_c('linearGradient',{attrs:{"id":"SVGID_2_","gradientUnits":"userSpaceOnUse","x1":"137.3","y1":"-389.4","x2":"137.3","y2":"-460.876","gradientTransform":"translate(0 498)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#b3b3b3","stop-opacity":".25"}}),_c('stop',{attrs:{"offset":".54","stop-color":"#b3b3b3","stop-opacity":".1"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#b3b3b3","stop-opacity":".05"}})]),_c('path',{attrs:{"fill":"url(#SVGID_2_)","d":"M170 37.2v71.4h-65.4v-6.2l59-65.2z"}}),_c('path',{attrs:{"fill":"#eee","d":"M104.5 102.4l59.1-65.2v65.2z"}})])
          )
        }
      }
    